"use strict";
/**
 * Keeps sold out product cards at the end of the collection grid.
 *
 * Liquid already renders each paginated page with the sold out products last, but
 * "Load more" / "Infinite scroll" append the next page after the previous one, which
 * interleaves the sold out cards of page 1 with the in-stock cards of page 2.
 * This re-sorts the merged grid whenever new cards are appended.
 */
(function () {
  var GRID = "#product-grid";
  var container = document.getElementById("productgridcontainer");
  if (!container) return;

  var scheduled = false;

  function items(grid) {
    return Array.prototype.slice.call(
      grid.querySelectorAll(":scope > .loadmore-item")
    );
  }

  function isSoldOut(el) {
    return el.getAttribute("data-sold-out") === "true";
  }

  /** True when an in-stock card sits after a sold out one. */
  function needsSort(list) {
    var seenSoldOut = false;
    for (var i = 0; i < list.length; i++) {
      if (isSoldOut(list[i])) {
        seenSoldOut = true;
      } else if (seenSoldOut) {
        return true;
      }
    }
    return false;
  }

  function sort() {
    scheduled = false;
    var grid = container.querySelector(GRID);
    if (!grid || !grid.classList.contains("loadmore-lists")) return;

    var list = items(grid);
    if (list.length < 2 || !needsSort(list)) return;

    var fragment = document.createDocumentFragment();
    for (var i = 0; i < list.length; i++) {
      if (isSoldOut(list[i])) fragment.appendChild(list[i]);
    }
    grid.appendChild(fragment);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(sort);
  }

  schedule();

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        schedule();
        return;
      }
    }
  }).observe(container, { childList: true, subtree: true });
})();
